export default __webpack_public_path__ + "static/media/LinkedIn.3fbad3a8.svg";